<template>
  <b-container fluid class="hkiarace-report">
    <b-row>
      <b-col>
        <h2>{{ $t('admin_report.title') }}</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card no-body>
          <b-tabs card v-model="tabIndex">
            <b-tab :title="$t('admin_report.registered_user')">
              <RegisteredUserReport></RegisteredUserReport>
            </b-tab>
            <b-tab :title="$t('admin_report.event_total_hour')">
              <EventHourReport></EventHourReport>
            </b-tab>
            <b-tab :title="$t('admin_report.category_application')">
              <EventApplicationReport></EventApplicationReport>
            </b-tab>
            <b-tab :title="$t('admin_report.event_attendance')">
              <EventAttendanceReport></EventAttendanceReport>
            </b-tab>
            <b-tab :title="$t('admin_report.special_offer_count')">
              <SpecialOfferCountReport></SpecialOfferCountReport>
            </b-tab>
            <b-tab :title="$t('admin_report.special_offer_view_count')">
              <SpecialOfferViewCountReport></SpecialOfferViewCountReport>
            </b-tab>
            <b-tab :title="$t('admin_report.corporate_vendor_view_count')">
              <CorporateVendorViewCountReport></CorporateVendorViewCountReport>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import RegisteredUserReport from "../../../components/report/RegisteredUserReport";
import EventHourReport from "../../../components/report/EventHourReport";
import EventApplicationReport from "../../../components/report/EventApplicationReport";
import EventAttendanceReport from "../../../components/report/EventAttendanceReport";
import SpecialOfferCountReport from "../../../components/report/SpecialOfferCountReport";
import SpecialOfferViewCountReport from "../../../components/report/SpecialOfferViewCountReport";
import CorporateVendorViewCountReport from "@/components/report/CorporateVendorViewCountReport";

export default {
  name: 'HkiaraceReport',
  components: {CorporateVendorViewCountReport, SpecialOfferViewCountReport, SpecialOfferCountReport, EventAttendanceReport, EventApplicationReport, EventHourReport, RegisteredUserReport},
  data() {
    return {
      tabIndex: 0,
    }
  },
}
</script>

<style lang="less">
.hkiarace-report {

}
</style>
